import moment from "moment-timezone";

export const fases = [
  { codigo: "COLETA", numero: 0, titulo: "Preparação", descricao: "Configure o administrador principal e os participantes da revisão da UF. Confirme a conclusão das avaliações da UF e do Nacional antes de iniciar." },
  { codigo: "REVISAO_TECNICA_NACIONAL", numero: 1, titulo: "Revisão Técnica Nacional", calculo: "Cálculo inicial", descricao: "Calcula a pontuação inicial e libera a equipe nacional para revisar os critérios avaliados pela UF. O fulladmin e os responsáveis indicados na preparação mantêm acesso; os demais usuários aguardam a liberação de sua etapa." },
  { codigo: "RESULTADO_PARCIAL_UF", numero: 2, titulo: "Resultado parcial da UF", calculo: "Recálculo 01", email: true, descricao: "Exige todas as revisões nacionais concluídas, encerra novos apontamentos nacionais e recalcula. Administradores visualizam os resultados liberados; pontuação e relatórios Ouro seguem protegidos. Envia a comunicação da liberação parcial." },
  { codigo: "REVISAO_TECNICA_UF", numero: 3, titulo: "Revisão Técnica da UF", descricao: "Libera administradores e usuários formalmente delegados. A UF pode solicitar revisão de critérios nacionais, pedir reanálise de seus próprios critérios e aceitar ou contestar apontamentos. A contestação aguarda decisão do Nacional; reanálises da UF são identificadas como não revisadas pelo Nacional." },
  { codigo: "RESULTADO_FINAL_UF", numero: 4, titulo: "Resultado final da UF", calculo: "Recálculo 02", email: true, descricao: "Exige todas as revisões da UF e do Nacional decididas. Bloqueia novas revisões, recalcula e comunica a liberação final. Os responsáveis indicados mantêm acesso ao sistema conforme seu grupo; Ouro permanece protegido." },
  { codigo: "RECURSOS_UF", numero: 5, titulo: "Recursos da UF — exceto Ouro", email: true, descricao: "Após a cerimônia estadual, libera participantes da etapa não Ouro para consultar seus relatórios e abrir recursos para a UF ou o Nacional, conforme o responsável pelo critério. Envia o prazo recursal." },
  { codigo: "FIM_RECURSOS_UF", numero: 6, titulo: "Fim do prazo para abertura de recursos", descricao: "Encerra o envio de novos recursos não Ouro conforme o cronograma. A UF e o Nacional concluem os recursos já recebidos." },
  { codigo: "POS_RECURSOS_UF", numero: 7, titulo: "Pós-recursos", calculo: "Recálculo 03", email: true, descricao: "Exige todos os recursos não Ouro decididos. Recalcula a pontuação e comunica a atualização dos relatórios e dos resultados liberados." },
  { codigo: "RECURSOS_OURO", numero: 8, titulo: "Recursos da UF — somente Ouro", email: true, descricao: "Após a cerimônia nacional e a autorização do Nacional, libera pontuação e relatórios Ouro, incluindo Diamante. Os recursos podem ser encaminhados à UF ou ao Nacional; a empresa responsável pela avaliação Nacional julga exclusivamente esses recursos. Envia o prazo desta etapa." },
  { codigo: "FIM_RECURSOS_OURO", numero: 9, titulo: "Fim do prazo para abertura de recursos — Ouro", descricao: "Encerra o envio de novos recursos Ouro conforme o cronograma. A empresa responsável pela avaliação Nacional conclui o julgamento dos recursos já recebidos." },
  { codigo: "POS_RECURSOS_OURO", numero: 10, titulo: "Pós-recursos — Ouro", calculo: "Recálculo 04", email: true, descricao: "Exige todos os recursos Ouro julgados pela empresa responsável pela avaliação Nacional. Recalcula, comunica a nova pontuação e encerra a execução preservando decisões, relatórios e histórico." },
];

export const acoesRepeticao = [
  { codigo: "RECALCULAR", titulo: "Refazer cálculo", descricao: "Atualiza a pontuação e os relatórios desta etapa, conferindo novamente as avaliações e decisões registradas.", sucesso: "Pontuação e relatórios recalculados." },
  { codigo: "REAPLICAR_ACESSOS", titulo: "Reaplicar acessos", descricao: "Reaplica as permissões de acesso definidas para a etapa atual.", sucesso: "Acessos da etapa reaplicados." },
  { codigo: "REAPLICAR_PRAZO", titulo: "Reaplicar prazo", descricao: "Confere as datas registradas e reaplica a abertura ou o encerramento do prazo desta etapa.", sucesso: "Prazo da etapa reaplicado." },
];

export function usuariosOrdenados(usuarios) {
  return (usuarios || []).map((u) => ({ ...u, rotulo: u.nome || `Usuário ${u.usuarioId}` }))
    .sort((a, b) => a.rotulo.localeCompare(b.rotulo, "pt-BR", { sensitivity: "base" }) || Number(a.usuarioId) - Number(b.usuarioId));
}

export function normalizarDados(value) {
  if (Array.isArray(value)) return value.map(normalizarDados);
  if (value && typeof value === "object") {
    return Object.keys(value).reduce((result, key) => {
      result[key.charAt(0).toLowerCase() + key.slice(1)] = normalizarDados(value[key]);
      return result;
    }, {});
  }
  return value;
}

export function numero(value) {
  if (value === null || value === undefined || value === "") return "Não apurado";
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed.toLocaleString("pt-BR", { maximumFractionDigits: 4 }) : String(value);
}

export function texto(value, ausencia = "Não registrado") {
  if (value === null || value === undefined || value === "") return ausencia;
  if (typeof value === "boolean") return value ? "Sim" : "Não";
  if (Array.isArray(value)) return value.length ? value.map((item) => texto(item)).join("; ") : ausencia;
  if (typeof value === "object") return Object.keys(value).map((key) => `${key}: ${texto(value[key])}`).join("; ");
  if (String(value).trim().toLowerCase() === "true") return "Sim";
  if (String(value).trim().toLowerCase() === "false") return "Não";
  return String(value).replace(/<br\s*\/?\s*>/gi, "\n").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim() || ausencia;
}

export function dataHora(value) {
  if (!value) return "Não registrado";
  const date = moment.utc(value).tz("America/Sao_Paulo");
  return date.isValid() ? date.format("DD/MM/YYYY [às] HH:mm [· Brasília]") : "Data não disponível";
}

export function dataHoraLocal(value) {
  if (!value) return "Não registrado";
  const date = moment.tz(value, "America/Sao_Paulo");
  return date.isValid() ? date.format("DD/MM/YYYY [às] HH:mm [· Brasília]") : "Data não disponível";
}

export function linkSeguro(value) {
  if (!value) return "";
  try {
    const parsed = new URL(String(value), window.location.origin);
    return ["http:", "https:"].includes(parsed.protocol) ? parsed.href : "";
  } catch (error) {
    return "";
  }
}

export function chaveOperacao() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
}

export function mensagemErro(error) {
  const payload = error && error.response && error.response.data;
  if (typeof payload === "string" && payload.trim()) return payload;
  return texto(payload && (payload.mensagem || payload.message || payload.erro || payload.Message),
    error && error.response && error.response.status === 403
      ? "Seu perfil não tem acesso a esta informação nesta fase do ciclo."
      : "Não foi possível concluir a operação. Atualize a página e tente novamente.");
}

export function criteriosOrdenados(relatorio) {
  return (relatorio.criterios || []).slice().sort((a, b) => Number(a.numero || a.ordem || 0) - Number(b.numero || b.ordem || 0));
}

export function memoriaCapacitacao(value) {
  if (!value) return null;
  const memoria = JSON.parse(JSON.stringify(value));
  const atendentes = (memoria.atendentes || []).length ? memoria.atendentes : (memoria.equipeInscrita || []).map((nome) => ({ nome }));
  memoria.atendentes = atendentes.map((a) => ({ contrataGestores2h: false, contrataMei1h: false, documentosRegulares: false, ciclo2026: false, limite10hDiaAplicado: false, ...a }));
  memoria.equipeInscrita = memoria.equipeInscrita || memoria.atendentes.map((a) => a.nome);
  return memoria;
}

export function memoriaCapacitacaoValida(value) {
  if (!value || !(value.atendentes || []).length || typeof value.alteracaoEquipeRegular !== "boolean" || String(value.justificativaEquipe || "").trim().length < 10) return false;
  return value.atendentes.every((a) => String(a.nome || "").trim() && String(a.justificativa || "").trim().length >= 10 && ["horasValidadas", "cursosDistintos", "inclusaoSocioprodutivaHoras", "competenciasComportamentaisHoras", "reformaTributariaHoras"].every((campo) => a[campo] !== null && a[campo] !== undefined && a[campo] !== "" && Number.isFinite(Number(a[campo])) && Number(a[campo]) >= 0) && ["contrataGestores2h", "contrataMei1h", "documentosRegulares", "ciclo2026", "limite10hDiaAplicado"].every((campo) => typeof a[campo] === "boolean"));
}

export function detalhesChecklist(item) {
  const detalhes = [];
  if (item.canal) detalhes.push(`Canal: ${item.canal}`);
  if (item.tentativa !== null && item.tentativa !== undefined) detalhes.push(`Tentativa: ${item.tentativa}`);
  if (typeof item.entraNoCalculo === "boolean") detalhes.push(item.entraNoCalculo ? "Item elegível para o cálculo" : "Registro de avaliação sem pontuação");
  if (item.pontuacaoMaxima !== null && item.pontuacaoMaxima !== undefined) detalhes.push(`Peso máximo: ${numero(item.pontuacaoMaxima)}`);
  if (item.pontuacaoObtida !== null && item.pontuacaoObtida !== undefined) detalhes.push(`Pontos obtidos: ${numero(item.pontuacaoObtida)}`);
  return detalhes.join(" · ");
}
